import React from "react";

/**
 * HawkamLogo — official brand shield mark.
 * The shield already contains "H", "حوكم" and "HAWKAM" wordmark.
 *
 * Props:
 *  - size: pixel height (width auto-scales via CSS aspect-ratio)
 *  - variant: "full" (shield + HAWKAM wordmark) | "mark" (shield-only, ideal for small spots / favicons)
 *  - className: extra Tailwind classes
 */
export default function HawkamLogo({ size = 40, variant = "full", className = "", alt = "HAWKAM" }) {
  const src =
    variant === "mark"
      ? "/brand/hawkam-shield-only.png"
      : "/brand/hawkam-shield-transparent.png";
  return (
    <img
      data-testid="hawkam-logo"
      src={src}
      alt={alt}
      style={{ height: size, width: "auto" }}
      className={`select-none pointer-events-none ${className}`}
      draggable={false}
    />
  );
}
